<section style="height: 100%">
  <div style="height: 100%;" class="row-flex header-block header-bg">
    <header class="col registration-1">
      <div class="logo-col">
        <a class="logo-delta-white-registration" [class.logo-ren-white-registration]="planFromUrl === 'ren'"><span class="sr-only">logo</span></a>
        <h1 class="h3">Benefit Manager Toolkit &reg;</h1>
      </div>
    </header>
    @if (isValidatingInfo()) {
    <rs-loader></rs-loader>
    }
    <main class="col registration-2">
      @if (!confirmation()) {
      <div class="registration-frame">
        @if (errorMessage()) {
        <div class="alert-danger">{{errorMessage()}}</div>
        }
        @if (!credentials()) {
        <app-register (registerSubmit)="registerSubmit($event)"></app-register>
        }
        @if (credentials()) {
        <app-credentials (credentialsSubmit)="credentialsSubmit($event)"></app-credentials>
        }
      </div>
      }
      @if (confirmation()) {
      <app-confirmation [userInfo]="userInfo()"></app-confirmation>
      }
    </main>
  </div>
</section>
